import { useNavigate, useSearchParams, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { DiaryStateContext } from "../App";

import DiaryEditor from "../components/DiaryEditor";

const Edit = () => {
  // const [searchParams, setSearchParmas] = useSearchParams();

  // const id = searchParams.get("id");
  // console.log(id);
  // const mode = searchParams.get("mode");
  // console.log(mode);

  const [originData, setOriginData] = useState();
  const navigate = useNavigate();
  const { id } = useParams();
  const diaryList = useContext(DiaryStateContext);

  // 세부 타이틀 바꾸기
  useEffect(() => {
    const titleElement = document.getElementsByTagName("title")[0];
    titleElement.innerHTML = `감정 일기장 - ${id}번 일기 수정`;
  }, []);

  useEffect(() => {
    if (diaryList.length >= 1) {
      const targetDiary = diaryList.find(
        (it) => parseInt(it.id) === parseInt(id)
      );

      if (targetDiary) {
        setOriginData(targetDiary);
      } else {
        alert("없는 일기입니다.");
        navigate("/", { replace: true }); // DiaryEditor.js 참고 - 뒤로가기 방지
      }
    }
  }, [id, diaryList]); // id 또는 diaryList가 바뀔 때만 실행

  return (
    <div>
      {originData && <DiaryEditor isEdit={true} originData={originData} />}
    </div>
    // <div>
    //   <h1>Edit</h1>
    //   <p>이곳은 일기 수정 페이지입니다.</p>
    //   <button onClick={() => setSearchParmas({ who: "hakjun" })}>
    //     Query String 바꾸기
    //   </button>
    //   <button
    //     onClick={() => {
    //       navigate("/home");
    //     }}
    //   >
    //     Home
    //   </button>
    //   <button
    //     onClick={() => {
    //       navigate(-1);
    //     }}
    //   >
    //     뒤로 가기
    //   </button>
    // </div>
  );
};

export default Edit;
